import { Button, Collapse, message, Modal, Radio, Space, Typography, Form, Input, Divider, Popconfirm, Tooltip } from "antd";
import { PlusSquareFilled, SaveFilled } from '@ant-design/icons';
import react, { useState } from "react";
import { EditIcon, UpdateIcon, TrashIcon, EyeIcon } from "../../admin/Icons";
import moment from "moment";

import wrap from "../../utils/wrap";
import { makeKey, tt_template_active, tt_template_edit, tt_template_inactive } from "../../utils/Utils";
import Overlay from "../Overlay";
import { useTemplate } from "../../utils/Template";
import { apiCall } from "../../utils/Api";

export default function Template(props) {

    const [template, setTemplate] = useTemplate();
    const { setTemplates = () => {}, templates = [], selected = false, data = {}, save = () => { }, remove = () => { }, set = () => { }, changed = false, is_new = false, is_edit = false, close = () => { } } = props;

    const {
        id = "",
        name = "",
        is_active = false,
    } = data;

    const date_updated = (data.date_updated) ? moment(data.date_updated * 1000) : moment().unix();


    const drawEdit = () => {
        let _title = (is_new) ? "New template" : "Edit template";
        return (
            <div style={{ "padding": "20px" }}>
                <Typography.Title level={5}>{_title}</Typography.Title>
                <Divider style={{ "margin": "15px 0px" }} dashed />
                <Form onFinish={(_f) => save(_f, is_new, close)} layout="vertical">
                    <Form.Item initialValue={name} rules={[{ required: true, message: "Template name is required." }]} name="name" label={<>Template name<small>&nbsp; (Max 10 chars)</small></>}>
                        <Input placeholder="Template name..." maxLength={10} />
                    </Form.Item>
                    <Form.Item name="id" initialValue={(id) ? id : makeKey()} noStyle>
                        <Input hidden />
                    </Form.Item>
                    <Form.Item name="date_updated" initialValue={date_updated} noStyle>
                        <Input hidden />
                    </Form.Item>
                    <Form.Item name="selected" initialValue={selected} noStyle>
                        <Input hidden />
                    </Form.Item>

                    <div className="float-flex">
                        <div>&nbsp;</div>
                        <div><Button htmlType="submit" type="primary">Save</Button></div>
                    </div>
                </Form>
            </div>
        )
    }


    const fetchTemplates = () => {
        apiCall("site_content/getTemplates", {}, (_status, _result) => {
          if (_status) {
            if (_result.length > 0) {
              setTemplates(_result);
            }  else {
                message.error("No template found.")
            }
          } else {
            message.error(_result.error)
          }
        })
      }
      
    const switchActiveTemplate = (id) => {

        const selected_template = templates.find(item => item.id === id);

        if(selected_template){
            let _template = {...selected_template, "is_active" : true};
          
            Modal.confirm({
                title : "Set active template?",
                content : <>This will switch your live theme.</>,
                onOk : () => {    
                    apiCall("site_content/setTemplate", {
                        ..._template,
                        colours: JSON.stringify(_template.colours),
                        gradients: JSON.stringify(_template.gradients),
                        buttons: JSON.stringify(_template.buttons),
                        texts: JSON.stringify(_template.texts),
                        fonts: JSON.stringify(_template.fonts),
                        links: JSON.stringify(_template.links)
                      }, (_status, _result) => {
                        if (_status) {
                            setTemplate(_template);
                            fetchTemplates();
                        } else {
                          message.error(_result.error)
                        }
                      })

                }
            })
        }


        

       

    }

    const drawRow = () => {
        return (
            <div key={id}>
                <div className="shim" />
                <div className="float-flex">
                    <Radio onClick={() => set(id)} checked={(selected)} key={id} value={id}>
                        <span style={{ "fontWeight": (selected) ? "bold" : "normal" }}>
                            <wrap.tags color="#1890ff" value={(selected && changed)}>{name}</wrap.tags>
                        </span>
                        <em><small> - {moment(date_updated).format("MM/DD/YY")}</small></em>
                    </Radio>
                    <Space size={0}>

                    <Tooltip title={(is_active) ? tt_template_active : tt_template_inactive}><Button onClick={() => switchActiveTemplate(id)} disabled={is_active} type="link" icon={<EyeIcon style={{"color" : (is_active) ? "#3c8617" : "#aaa"}} />} size="small" /></Tooltip>
                        <Overlay disabled={!selected} width="300px" component={<Template changed={changed} is_edit save={save} set={set} data={data} />}>
                            <Tooltip title={tt_template_edit}><Button disabled={!selected} type="link" icon={<EditIcon />} size="small" /></Tooltip>
                        </Overlay>
                        <Popconfirm disabled={selected || is_active} onConfirm={() => remove(id)} title={"Are you sure?"} >
                            <Button disabled={selected || is_active} type="link" icon={<TrashIcon disabled={selected || is_active} />} size="small" />
                        </Popconfirm>
                    </Space>
                </div>
            </div>
        )
    }


    if (is_new || is_edit) {
        return drawEdit();
    } else {
        return drawRow();
    }




}